export default __webpack_public_path__ + "static/media/pendProceso.6e7bbdb7.svg";